import getField from '@form/formGenerator'

export const feedBackSaveUrl = `${import.meta.env.VITE_API_URL}/api/feed-backs/respond`

export const feedBackFormObject = {
  id: null,
  name: null,
  isActive: false
}

export const feedBackFormFields = (feedBackFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'note',
      label: t('labels.note'),
      value: feedBackFormObject.note,
      key: 'feedBackFormObject-note',
      cssClass: 'column is-12'
    },
    {
      type: 'textarea',
      name: 'comment',
      label: t('labels.comment'),
      value: feedBackFormObject.comment,
      key: 'feedBackFormObject-comment',
      cssClass: 'column is-12'
    },
    {
      type: 'textarea',
      name: 'response',
      label: t('labels.response'),
      value: feedBackFormObject.response,
      key: 'feedBackFormObject-response',
      cssClass: 'column is-12'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'feedBackFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(feedBackFormObject.id),
      key: 'feedBackFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}